enum AppServices {
  MachinesGroupsService = 'MachinesGroupsService',
  UserService = 'UserService',
  TagsService = 'TagsService',
  StopSettingsService = 'StopSettingsService',
  KpiReportService = 'KpiReportService',
  ShiftService = 'ShiftService',
  MachineService = 'MachineService',
  RealTimeService = 'RealTimeService',
  StopsService = 'StopsService',
  ShiftSettingsService = 'ShiftSettingsService',
  MultipleStopsService = 'MultipleStopsService',
  ProductionService = 'ProductionService',
  WhatsNewService = 'WhatsNewService',
  WorkOrdersService = 'WorkOrdersService',
  MachineUIMetricsConfigService = 'MachineUIMetricsConfigService',
  ReportsService = 'ReportsService',
  CustomFieldsService = 'CustomFieldsService',
  RawMaterialService = 'RawMaterialService',
  SkuService = 'SkuService'
}

export default AppServices;
export * from './rawMaterial.service';
